/* eslint-disable no-undef */
/**
 * /*
 * 文件名: edusso.js
 * 描述: 提供对 CAS 单点登录的封装
 *
 * 功能说明：
 * 实现多个应用之间的单点登录（SSO）功能，应用可以部署在不同的域名。
 *
 * 版本: 1.0.0.1
 * 作者: jhzhang@iflytek.com
 * 日期：2013/10/20
 *
 * @format
 */

import jQuery from 'jquery'

/**
 * @param serviceUrl - 应用部署地址，PHP 网站请使用 ssoservice.php 所在 Url，
 *   JAVA 网站对应 ssoservice.jsp 所在 Url，否则需要自己处理单点登出事件。
 * @param casUrl - CAS 认证中心地址
 **/
export default class EduSSO {
  public _casUrl: string
  public _centerCasUrl: string
  public _serviceUrl: string
  public _zpSession: string
  constructor(serviceUrl: string, casUrl: string, centerCasUrl: string,zpSession:string) {
    this._casUrl = casUrl;
    this._centerCasUrl = centerCasUrl;
    this._serviceUrl = serviceUrl;
    this._zpSession=zpSession;
  }

  _callback (cb: (data: unknown) => void, data: unknown): void {
    if (typeof cb == 'function') {
      cb(data);
    }
  }


  _realCasLogin (callback, params: any, retry): void {
    const loginURL = this._casUrl + '/login?service=' + encodeURIComponent(this._serviceUrl);

    jQuery.ajax({
      url: loginURL,
      type: 'GET',
      dataType: 'jsonp',
      jsonp: 'callback',
      data: params,
      crossDomain: true,
      cache: false,
      success: (html) => {
        html = jQuery.trim(html).replace(/\t/g, '');
        const resultobj = jQuery.evalJSON(html);
        if (resultobj.result && resultobj.result == 'success') {
          if (parseInt(resultobj.code) == 1000 && !retry) {
            //try again
            this._realCasLogin(callback, params, true);
            return;
          }

          //Ajax to service
          if (resultobj.data && resultobj.data.st) {
            this._serviceLogin(
              callback,
              params.username,
              params.password,
              resultobj.data.st
            );
            return;
          }
        }

        this._callback(callback, resultobj);
      },
      error: () => {
        const resultobj = {
          result: 'fail',
          code: '-1',
          data: '登录CAS失败，出现异常！'
        };
        this._callback(callback, resultobj);
      }
    });
  }

  /**
     * 用户登录
     * @param username - 用户名
     * @param password - 密码
     * @param key - `login_name`, `email`, `mobile`
     **/
  login (
    appname,
    sourceappname,
    methodkey,
    username,
    password,
    callback
  ) {
    const centerloginURL = this._centerCasUrl + '/login?service=' + encodeURIComponent(this._serviceUrl);

    jQuery.ajax({
      url: centerloginURL,
      type: 'GET',
      dataType: 'jsonp',
      jsonp: 'callback',
      crossDomain: true,
      cache: false,
      async: false,
      success: (html) => {
        html = jQuery.trim(html).replace(/\t/g, '');
        const resultobj = jQuery.evalJSON(html);
        if (resultobj.result && resultobj.result == 'success') {
          //已经登录了
          if (
            parseInt(resultobj.code) == 1001 &&
            resultobj.data &&
            resultobj.data.st
          ) {
            this.centerLogout();
            return;
          }
        }
      },
      error: (data) => {
        console.log(data);
      }
    });
    const loginURL =
      this._casUrl +
      '/login?service=' +
      encodeURIComponent(this._serviceUrl);

    jQuery.ajax({
      url: loginURL,
      type: 'GET',
      dataType: 'jsonp',
      jsonp: 'callback',
      crossDomain: true,
      cache: false,
      success: (html) => {
        html = jQuery.trim(html).replace(/\t/g, '');
        const resultobj = jQuery.evalJSON(html);
        if (resultobj.result && resultobj.result == 'success') {
          //已经登录了
          if (
            parseInt(resultobj.code) == 1001 &&
            resultobj.data &&
            resultobj.data.st
          ) {
            this.logout(() => {
              setTimeout(() => {
                this.login(
                  appname,
                  sourceappname,
                  methodkey,
                  username,
                  password,
                  callback
                );
              }, 100);
              return;
            });

            return;
          }

          const pl = {} as any;
          pl.username = username;
          //pl.password = password;
          pl.encode = true;
          const exponent = '010001';
          const modulus = '008c147f73c2593cba0bd007e60a89ade5';
          const key = window.RSAUtils.getKeyPair(exponent, '', modulus);
          pl.password = window.RSAUtils.encryptedString(key, password);
          pl.sourceappname = appname + ',' + sourceappname;
          pl.key = methodkey;
          pl._eventId = 'submit';
          pl.lt = resultobj.data.lt;
          pl.execution = resultobj.data.execution;

          this._realCasLogin(callback, pl, false);
        } else {
          this._callback(callback, resultobj);
        }
      },
      error: (data) => {
        const resultobj = {
          result: 'fail',
          code: '-1',
          data: '登录失败，出现异常！'
        };
        this._callback(callback, resultobj);
      }
    });
  }

  logoutzp (callback) {
    const logoutURL = this._zpSession + '?action=logout';

    jQuery.ajax({
      url: logoutURL,
      type: 'GET',
      dataType: 'jsonp',
      jsonp: 'callback',
      crossDomain: true,
      cache: false,
      success: (html) => {
      
        if (html == 'success') {
          this.centerLogout();
          this._serviceLogout(callback);
          return;
        }

      //  this._callback(callback, resultobj);
      },
      error: (data) => {
        const resultobj = {
          result: 'fail',
          code: '-1',
          data: '登出失败，出现异常！'
        };
        this._callback(callback, resultobj);
      }
    });
  }
  /**
    * 用户登出一般总是返回成功
    **/
  logout (callback) {
    const logoutURL = this._casUrl + '/logout';

    jQuery.ajax({
      url: logoutURL,
      type: 'GET',
      dataType: 'jsonp',
      jsonp: 'callback',
      crossDomain: true,
      cache: false,
      success: (html) => {
        html = jQuery.trim(html).replace(/\t/g, '');
        const resultobj = JSON.parse(html);
        if (resultobj.result && resultobj.result == 'success') {
          this.centerLogout();
          this._serviceLogout(callback);
          return;
        }

        this._callback(callback, resultobj);
      },
      error: (data) => {
        const resultobj = {
          result: 'fail',
          code: '-1',
          data: '登出失败，出现异常！'
        };
        this._callback(callback, resultobj);
      }
    });
  }


  _serviceLogin (callback, username, password, serviceTicket) {
    const pl = {} as any;
    pl.action = 'login';
    pl.username = username;
    pl.password = password;
    pl.ticket = serviceTicket;

    jQuery.ajax({
      url: this._serviceUrl,
      type: 'POST',
      data: pl,
      cache: false,
      success: (html) => {
        html = jQuery.trim(html).replace(/\t/g, '');
        const resultobj = {
          result: 'success',
          code: 3001,
          data: html,
        };

        this._callback(callback, resultobj);
      },
      error: (data) => {
        const resultobj = {
          result: 'fail',
          code: '-1',
          data: '登录Service失败，出现异常！'
        };
        this._callback(callback, resultobj);
      }
    });
  }


  _serviceLogout (callback) {
    const pl = {
      action: 'logout'
    };

    jQuery.ajax({
      url: this._serviceUrl,
      type: 'POST',
      data: pl,
      cache: false,
      success: (html) => {
        html = jQuery.trim(html).replace(/\t/g, '');
        const resultobj = {
          result: 'success',
          code: 4001,
          data: html,
        };

        this._callback(callback, resultobj);
      },
      error: (data) => {
        const resultobj = {
          result: 'fail',
          code: '-1',
          data: '登出Service失败，出现异常！'
        };
        this._callback(callback, resultobj);
      }
    });
  }



  /**
   * 同步tgt到中心
   **/
  syncToCenterSSO (callback) {
    const syncUrl =
      this._casUrl +
      '/login?service=' +
      encodeURIComponent(this._serviceUrl + '?isAjax=true') +
      '&redirect=true';
    jQuery.ajax({
      url: syncUrl,
      type: 'get',
      dataType: 'jsonp',
      jsonp: 'callback',
      jsonpCallback: 'jsonpCallback',
      xhrFields: {
        withCredentials: true
      },
      crossDomain: true,
      timeout: 3000,
      complete: () => {
        callback && callback();
      }
    })
  }


  /**
   * 中心sso退出
   **/
  centerLogout () {
    const logoutURL = this._centerCasUrl + '/logout';

    jQuery.ajax({
      url: logoutURL,
      type: 'GET',
      dataType: 'jsonp',
      jsonp: 'callback',
      crossDomain: true,
      cache: false,
      async: false,
      success: (data) => {
        console.log(data);
      },
      error: (data) => {
        console.log(data);
      }
    });
  }

}
